<template>
    <div class="analysis-container">
        <h2>{{translate("detailed_analysis")}}</h2>
        <div class="detail-fan-title">{{getActiveFun.type}}&nbsp;&nbsp;{{getActiveFun.model}}</div>
        <main>
            <graphs-analysis-aside></graphs-analysis-aside>
            <analysis-graphs></analysis-graphs>
            <div class="empty-aside"></div>
        </main>
    </div>
</template>

<script>
    import AnalysisGraphs from "../components/analysis/AnalysisGraphs";
    import GraphsAnalysisAside from "../components/analysis/GraphsAnalysisAside";

    export default {
        name: "DetailAnalysis",
        components: {GraphsAnalysisAside, AnalysisGraphs},
        data() {
            return {

            }
        },

        methods: {
            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                };

                this.$store.commit(arg);

                return arg.out;
            },
        },

        computed: {
            getActiveFun() {
                return this.$store.state.activeFun;
            },
        }
    }
</script>

<style scoped>

</style>